module.exports = __webpack_public_path__ + "img/wall.160225a2.png";